var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 6.79297H4.75V8.20964H3.25V6.79297ZM13.75 3.2513V13.168C13.75 13.9471 13.075 14.5846 12.25 14.5846H1.75C0.9175 14.5846 0.25 13.9471 0.25 13.168L0.2575 3.2513C0.2575 2.47214 0.9175 1.83464 1.75 1.83464H2.5V0.417969H4V1.83464H10V0.417969H11.5V1.83464H12.25C13.075 1.83464 13.75 2.47214 13.75 3.2513ZM1.75 4.66797H12.25V3.2513H1.75V4.66797ZM12.25 13.168V6.08464H1.75V13.168H12.25ZM9.25 8.20964H10.75V6.79297H9.25V8.20964ZM6.25 8.20964H7.75V6.79297H6.25V8.20964Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.c7ae5a4295b4772adb0df88e26c48d82.svg";
export { ForwardRef as ReactComponent };